'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './template-upload.routes';

export class TemplateUploadComponent {
  constructor(Auth, $state, $stateParams, dialogs, TemplateService, Upload) {
    'ngInject';

    this.templateId = $stateParams.id;

    this.dialogs = dialogs;
    this.TemplateService = TemplateService;
    this.Auth = Auth;
    this.Upload = Upload;

    this.jsonValue = "";
    this.$state = $state;

    this.schema = {
      type: "object",
      properties: {
        name: {
          type: "string",
          title: "Name"
        },
        description: {
          type: "string",
          title: 'Description'
        }
      }
    };

    this.form = [
      "*"
    ];

    this.model = {
    };

  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    if (form.$valid) {

      var onSuccess = () => {
        var dlg = this.dialogs.notify("Success", "The template has been created successfully");
        dlg.result.then(() => {
          that.$state.go("template-list");
        });
      };

      var onError = err => {
        this.sendFailure = true;
      };

      let userId = this.Auth.getCurrentUserSync()._id;

      this.Upload.upload({
        url: '/api/storage',
        data: {
          name: this.templateFile.name,
          file: this.templateFile,
          storageStrategy: 'local',
          creationUser: userId,
          active: true
        }
      }).then(
        (res) => {

          this.model.template = res.data;
          this.model.meta = {creationUser: userId};
          this.TemplateService.save(this.model, onSuccess, onError);

        },
        (err) => {
          this.sendFailure = true;
        });

    }
  }
}

export default angular.module('conduu.templateUpload', [uiRouter])
  .config(routes)
  .component('templateUpload', {
    template: require('./template-upload.html'),
    controller: TemplateUploadComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/template/template-upload/template-upload.component.js